<template>
  <figure class="table-figure">
    <table>
      <thead>
        <tr>
          <th><strong>Who processes your data?</strong></th>
          <th><strong>MAPPREXPLORE, S.L.</strong> (hereinafter, “MAPPR”).</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><strong>Why do we process your data?</strong></td>
          <td>
            i) Register you as a new user; <br />ii) Properly manage the
            requests made through the website, as well as the payment of the
            selected subscription or login; <br />iii) Respond to your requests
            for information, complaints, claims or technical assistance; iv)
            Compliance with legal obligations; and v) Depending on your cookie
            settings, to perform statistical analysis and profiling based on
            your browsing habits.
            <strong
              ><NuxtLink to="/info/privacy-policy">+ info</NuxtLink></strong
            >
          </td>
        </tr>
        <tr>
          <td>
            <strong
              >What is the legal basis for the processing of your data?</strong
            >
          </td>
          <td>
            i) The performance of a contract and/or the implementation of
            pre-contractual measures necessary to provide the services requested
            through the website; <br />ii) The performance of a contract and/or
            the implementation of pre-contractual measures; <br />iii)
            Compliance with a legal obligation; and iv) The data subject’s
            consent, as the lawful basis for processing.
            <strong
              ><NuxtLink to="/info/privacy-policy">+ info</NuxtLink></strong
            >
          </td>
        </tr>
        <tr>
          <td><strong>Will your data be shared or transferred?</strong></td>
          <td>
            The data will be processed by third party providers to carry out the
            purposes, such as, for example, hosting services. Data may also be
            disclosed to competent authorities and bodies, courts, tribunals or
            any other third parties entitled to do so in order to comply with
            the applicable regulations.
            <strong
              ><NuxtLink to="/info/privacy-policy">+ info</NuxtLink></strong
            >
          </td>
        </tr>
        <tr>
          <td><strong>What are my rights?</strong></td>
          <td>
            You may exercise the following
            rights:AccessRectificationErasureObjectionData
            PortabilityRestriction of ProcessingThe right not to be subject to
            automated individual decision-making. + <strong>info</strong>
          </td>
        </tr>
        <tr>
          <td><strong>Questions?</strong></td>
          <td>
            Contact us at:
            <a href="mailto:rgpd@mappr.com">rgpd@mappr.com</a> for any queries
            or to unsubscribe. <strong>+info</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </figure>
</template>

<style scoped>
table {
  text-align: left;
  border-collapse: collapse;
  max-width: 50rem;
  margin: 2rem 1rem;
}
th {
  padding: 0.5rem;
  align-items: start;
  background-color: var(--color-slate-100);
}
td {
  padding: 0.5rem;
  align-items: start;
  vertical-align: top;
  line-height: 1.5;
}

a {
  color: var(--color-indigo-500);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
